import { Plus, X } from 'lucide-react';
import CustomInput from '../../../../../../components/forms/CustomInput';

const CategoryDetails = ({
  role,
  formData,
  handleChange,
  activitiesList,
  onAddActivity,
  onRemoveActivity
}) => {
  if (role === 'Restaurant') {
    return (
      <div className="max-w-md">
        <CustomInput
          label="Price for 2 (₹)"
          type="number"
          name="price_for_two"
          value={formData.price_for_two}
          onChange={handleChange}
          placeholder="e.g. 1500"
        />
      </div>
    );
  }

  if (role === 'Activity') {
    return (
      <div className="space-y-3 sm:space-y-4 bg-slate-50 p-3.5 sm:p-5 rounded-2xl border border-slate-100">
        <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
          Activities offered
        </label>

        <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-start">
          <div className="flex-1 space-y-2.5 sm:space-y-3">
            <CustomInput
              name="newActivityName"
              value={formData.newActivityName}
              onChange={handleChange}
              placeholder="Activity Name (e.g. Scuba Diving)"
            />
            <CustomInput
              name="newPackageName"
              value={formData.newPackageName}
              onChange={handleChange}
              placeholder="Package (Optional, e.g. 30 Mins)"
            />
          </div>
          <button
            type="button"
            onClick={onAddActivity}
            className="p-2.5 sm:p-3 bg-[#067978] text-white rounded-xl hover:bg-[#056362] transition-colors flex items-center justify-center gap-2 font-bold text-xs cursor-pointer shadow-sm h-[42px]"
          >
            <Plus size={18} />
            <span className="sm:hidden">Add Activity</span>
          </button>
        </div>

        {activitiesList.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-3 sm:mt-4">
            {activitiesList.map((act, index) => (
              <div
                key={index}
                className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border border-slate-200 text-xs sm:text-sm shadow-xs"
              >
                <span className="font-semibold text-slate-700">{act.name}</span>
                {act.packages && act.packages[0] && (
                  <span className="text-slate-400 text-xs">({act.packages[0]})</span>
                )}
                <button
                  type="button"
                  onClick={() => onRemoveActivity(index)}
                  className="text-slate-400 hover:text-rose-500 ml-1 cursor-pointer transition-colors"
                >
                  <X size={14} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default CategoryDetails;
